//productSelector.js
(function($, window, document) {
  'use strict';

  $(function() {
    // place modals at the place where people click
    $("[data-toggle='modal']").on('click', function(e) {
      var analyticsRoot =
        $(this)
          .text()
          .replace(/\s+/g, '') + 'View';

      sendGAPageView(analyticsRoot, {}, analyticsRoot);

      if (window.screen.width < 767 || window.innerWidth < 767) {
        return;
      }

      var modal = $(this).data('target');
      $(modal + ' .modal-dialog').css({ top: 0 });
    });

    $('#heaters-index').delegate('.results-cta button', 'click', function(e) {
      var analyticsRoot =
        $(this)
          .text()
          .replace(/\s+/g, '') + 'View';

      sendGAPageView(analyticsRoot, {}, analyticsRoot);

      var modelNumber = $(this)
        .parent('.results-cta')
        .data('model');
      SetGaEvents('Contact', modelNumber, $(this).text());

      if (window.screen.width < 767 || window.innerWidth < 767) {
        return;
      }

      var modal = $(this).data('target');
      $(modal + ' .modal-dialog').css({ top: 0 });
    });

    // get initial zip code
    $.getJSON('https://stage.whmaas.com/api/ip/zip', function(response) {
      $('#zipcode').val(response.results.PostalCode);
    });

    var firstTimeThrough = true;

    $('.heaters-results').hide();
    $('div.progressbar').hide();

    var gaEvents = [];

    var SetGaEvents = function SetGaEvents(category, action, label) {
      try {
        ga(
          'send',
          'event',
          'PST - ' + category + (gaInitial ? '' : '-Add'),
          action,
          label
        );
      } catch (err) {}
    };

    function sendGAPageView(root, extraParams, title) {
      var userParams = {
        ID: userPreferences.userID,
        brandid: userPreferences.brandid,
        sessionID: sessionID
      };
      var allFields = $.extend({}, userParams, requestParms, extraParams, {
        price: requestParms.price
      });
      var fullQuery = encodeURIComponent($.param(allFields));

      ga('send', {
        hitType: 'pageview',
        page: '/' + root + '?' + fullQuery,
        title: title
      });
    }

    $('label.btn-info').click(function(e) {
      e.preventDefault();
      e.stopPropagation();

      // clear out selected for all siblings
      $(this)
        .siblings()
        .removeClass('selected');
      // get panel index
      var panelIndex = $(this)
        .parents('div.panel-body')
        .siblings('header.panel-header')
        .children('div.panel-index')
        .text();
      var answer = $(this)
        .children('span.field-title')
        .text();
      if (panelIndex == '') {
        panelIndex = $(this)
          .parents('div.modal-body')
          .siblings('div.modal-header')
          .children('h4.modal-title')
          .text();
      }
      var textNumber = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five'];
      switch (panelIndex) {
        case '1':
          switch (answer) {
            case 'Short':
              requestParms.longestShower = 5;
              break;
            case 'Average':
              requestParms.longestShower = 8;
              break;
            case 'Long':
              requestParms.longestShower = 15;
              break;
            case 'Luxurious':
              requestParms.longestShower = 25;
              break;
            case 'Epic':
              requestParms.longestShower = 45;
              break;
          }
          SetGaEvents('Hot Water Usage', 'Enjoy a Shower', answer);
          ignoreUpdate = true;
          sliderSingleShowerLength.noUiSlider.set(
            parseInt(requestParms.longestShower)
          );
          requestParms.averageShowerLength = 8;
          sliderAverageShowerLength.noUiSlider.set(
            parseInt(requestParms.averageShowerLength)
          );
          break;
        case '2':
          requestParms.backToBackShowers = parseInt(answer.substring(0, 1));
          ignoreUpdate = true;
          sliderBackToBackShowers.noUiSlider.set(
            parseInt(requestParms.backToBackShowers)
          );
          SetGaEvents(
            'Hot Water Usage',
            'Back to Back Showers',
            textNumber[requestParms.backToBackShowers]
          );
          break;
        case '3':
          requestParms.simultaneousShowers = parseInt(answer.substring(0, 1));
          ignoreUpdate = true;
          sliderSimultaneousShowers.noUiSlider.set(
            parseInt(requestParms.simultaneousShowers)
          );
          SetGaEvents(
            'Hot Water Usage',
            'Showers Same Time',
            textNumber[requestParms.simultaneousShowers]
          );
          break;
        case '4':
          switch (answer) {
            case 'Small':
              requestParms.largestBathTub = 35;
              break;
            case 'Standard':
              requestParms.largestBathTub = 55;
              break;
            case 'Large':
              requestParms.largestBathTub = 75;
              break;
            case 'Oversized':
              requestParms.largestBathTub = 100;
              break;
            case 'Custom':
              // show modal
              $('#modalTubSize').modal('show');
              return;
          }
          SetGaEvents('Hot Water Usage', 'Bath Tub Size', answer);
          ignoreUpdate = true;
          sliderTubSize.noUiSlider.set(parseInt(requestParms.largestBathTub));
          break;
        case '5':
          if (answer == 'No') {
            requestParms.showerFlowRate = userPreferences.showerflowrate || 2.1;
            SetGaEvents(
              'Hot Water Usage',
              'High Flow Rate Showerheads',
              answer
            );
          } else {
            $('#modalSpecialtyShower').modal('show');
            SetGaEvents(
              'Hot Water Usage',
              'High Flow Rate Showerheads',
              answer
            );
            return;
          }
          break;
        case '6':
          switch (answer) {
            case 'Natural Gas':
              requestParms.energySource = 'naturalgas';
              $('#modalVentingPreference').modal('show');
              $(this)
                .siblings()
                .removeClass('selected');
              $(this).addClass('selected');
              break;
            case 'Propane':
              requestParms.energySource = 'propanegas';
              $('#modalVentingPreference').modal('show');
              $(this)
                .siblings()
                .removeClass('selected');
              $(this).addClass('selected');
              break;
            case 'Electricity':
              requestParms.energySource = 'electric';
              break;
          }
          SetGaEvents('Power Source & Location', 'Heating Source', answer);
          break;
        case '7':
          switch (answer) {
            case 'Plenty':
              requestParms.spaceHeight = 84;
              requestParms.spaceWidth = 28;
              requestParms.spaceDepth = 28;
              break;
            case 'Short':
              requestParms.spaceHeight = 60;
              requestParms.spaceWidth = 28;
              requestParms.spaceDepth = 28;
              break;
            case 'Narrow':
              requestParms.spaceHeight = 84;
              requestParms.spaceWidth = 24;
              requestParms.spaceDepth = 24;
              break;
            case 'Custom':
              $('#modalInstallationSpace').modal('show');
              $(this)
                .siblings()
                .removeClass('selected');
              $(this).addClass('selected');
              return;
          }
          SetGaEvents(
            'Power Source & Location',
            'Amount of Space',
            requestParms.spaceHeight +
              'x' +
              requestParms.spaceWidth +
              'x' +
              requestParms.spaceDepth
          );
          break;
        case 'Venting Preference':
          // venttype modal
          switch (answer) {
            case "I'm Not Sure":
              requestParms.ventingPreference = 'NotSure';
              break;
            case 'Standard':
              requestParms.ventingPreference = 'StandardVent';
              break;
            case 'Direct':
              requestParms.ventingPreference = 'DirectVent';
              break;
            case 'Power':
              requestParms.ventingPreference = 'PowerVent';
              break;
            case 'Power Direct':
              requestParms.ventingPreference = 'PowerDirectVent';
              break;
          }
          break;
        default:
          var x = 1;
          break;
      }
      // set selected on self
      $(this).addClass('selected');

      // Handle venting preference modal choice
      if (panelIndex == 'Venting Preference') {
        if (answer == "I'm Not Sure") {
          $(this)
            .siblings('div#btn-venting-options')
            .children('.btn-info')
            .removeClass('selected');
          $(this).addClass('selected');
        } else {
          $(this)
            .parent()
            .siblings()
            .removeClass('selected');
          $(this)
            .siblings()
            .removeClass('selected');
          $(this).addClass('selected');
        }

        var energy = 'Natural Gas';

        if (requestParms.energySource == 'propanegas') {
          energy = 'Propane Gas';
        }

        UpdateModalOption(
          '6',
          '7',
          energy + ' (' + panelIndex + ': ' + answer + ')'
        );
        $('#modalVentingPreference').modal('hide');

        return false;
      }

      // Replace panel-title answer with selected value
      var note = $(this)
        .children('span.field-note')
        .text()
        .trim();

      if (typeof note == 'undefined' || note == '') {
        note = '';
      } else {
        note = ' (' + note + ')';
      }

      answer += note;

      $(this)
        .parents('div.panel-body')
        .siblings('header.panel-header')
        .children('h2.panel-title.answer')
        .text(answer);
      // remove active class on parent
      $(this)
        .parents('div.panel')
        .removeClass('active');
      // set completed class on parent
      $(this)
        .parents('div.panel')
        .addClass('completed');
      // set next question to active
      $(this)
        .parents('div.panel')
        .next()
        .addClass('active');

      if (panelIndex == 7) {
        // set focus on zipcode text box
        $('input[id$="zipcode"]').focus();
      }
      return false;
    });

    var UpdateModalOption = function UpdateModalOption(
      from,
      to,
      text,
      modalName
    ) {
      if (typeof modalName !== 'undefined') {
        $('#' + modalName).modal('hide');
        var $modalLabel = $('label[data-target="#' + modalName + '"]');
        $modalLabel.siblings().removeClass('selected');
        $modalLabel.addClass('selected');
      }
      var $from = $(
        '.panel header.panel-header .panel-index:contains("' + from + '")'
      );
      $from.siblings('h2.panel-title.answer').text(text);
      $from.parents('.panel').removeClass('active');
      $from.parents('.panel').addClass('completed');
      $('.panel header.panel-header .panel-index:contains("' + to + '")')
        .parents('.panel')
        .addClass('active');
    };

    $('#btnTubSize').click(function(e) {
      var temp = $('input[name="custom_tub_size"]').val();
      if (temp == '') {
        return false;
      }
      requestParms.largestBathTub = temp;
      SetGaEvents(
        'Hot Water Usage',
        'Custom Shower Flow Rate',
        requestParms.largestBathTub
      );
      UpdateModalOption(
        '4',
        '5',
        'Custom (' + temp + ' gallons)',
        'modalTubSize'
      );
      sliderTubSize.noUiSlider.set(parseInt(requestParms.largestBathTub));
      return false;
    });

    $('#btnSpecialtyShower').click(function(e) {
      var temp = $('input[name="custom_gpm"]').val();
      if (temp == '') {
        return;
      }
      requestParms.customShowerFlowRate = temp;
      UpdateModalOption(
        '5',
        '6',
        'Custom Shower Flow Rate (' + temp + ' gpm)',
        'modalSpecialtyShower'
      );
      SetGaEvents(
        'Hot Water Usage',
        'Custom Shower Flow Rate',
        requestParms.customShowerFlowRate
      );
      return false;
    });

    $('#btnSpecialtyShowerIDontKnow').click(function(e) {
      $('#question1').hide();
      $('#idontknow').show();
      return false;
    });

    $('#btnSpecialtyShowerBack').click(function(e) {
      $('#question1').show();
      $('#idontknow').hide();
      return false;
    });

    $('#btnSpecialtyShowerUndo').click(function(e) {
      $('#question1').show();
      $('#idontknow').hide();
      $('#modalSpecialtyShower').modal('hide');
    });

    $('#btnSpecialtyShowerGetHelp').click(function(e) {
      window.location.href =
        'https://www.lowes.com/cd_Water+Heater+Install_609934316_?UserSearch=water+heater+installation';
      return false;
    });

    $('#btnInstallationSpace').click(function(e) {
      var tempH = $('input[name="install_space_h"]')
        .val()
        .trim();
      var tempW = $('input[name="install_space_w"]')
        .val()
        .trim();
      var tempD = $('input[name="install_space_d"]')
        .val()
        .trim();
      if (tempH == '' || tempW == '' || tempD == '') {
        return;
      }
      requestParms.spaceHeight = tempH;
      requestParms.spaceWidth = tempW;
      requestParms.spaceDepth = tempD;
      SetGaEvents(
        'Power Source & Location',
        'Amount of Space',
        requestParms.spaceHeight +
          'x' +
          requestParms.spaceWidth +
          'x' +
          requestParms.spaceDepth
      );
      $('#modalInstallationSpace').modal('hide');
      // dont' pass modal name for this one.  different markup structure
      UpdateModalOption(
        '7',
        '8',
        'Custom Installation Space (' +
          tempH +
          '" x ' +
          tempW +
          '" x ' +
          tempD +
          '")'
      );
      return false;
    });

    $('div.panel').click(function(e) {
      if (!$(this).hasClass('completed')) {
        e.preventDefault();
        return false;
      }

      $('div.panel').removeClass('active');
      $(this).addClass('active');
      e.preventDefault();
      return false;
    });

    $('input[id$="zipcode"]').keypress(function(e) {
      if (e.which == 13) {
        requestParms.model = '';
        $('#get-results').click();
        return false;
      }
    });

    $('#show-more').click(function(e) {
      var text = $(this).text();

      if (text == 'Show More') {
        $(this).text('Show Less');
        tankUnitsToShow = 7;
        tanklessUnitsToShow = 3;
      } else {
        $(this).text('Show More');
        tankUnitsToShow = 2;
        tanklessUnitsToShow = 1;
      }

      var sortOrder = 'bestMatchScore';
      var sortBy = 'BestMatch';

      if ($('.btn-sort.moreHotWaterScore').hasClass('active')) {
        sortOrder = 'moreHotWaterScore';
        sortBy = 'BestHotWater';
      }

      if ($('.btn-sort.moreSavingsScore').hasClass('active')) {
        sortOrder = 'moreSavingsScore';
        sortBy = 'BestSavings';
      }

      try {
        ga(
          'send',
          'event',
          'PST - Results Page Sorted By' + sortBy,
          text + ' Link'
        );
      } catch (err) {}

      $('#heaters-index').html('');

      var list = [];
      list = BuildListOfUnits(sortOrder);
      ShowListOfUnits(list);
    });

    $('#start-over, #start-over-no-results').click(function(e) {
      $('.panel header.panel-header .panel-index:contains("8")')
        .parents('.panel')
        .removeClass('active');
      $('.panel header.panel-header .panel-index:contains("1")')
        .parents('.panel')
        .addClass('active');
      $('.heaters-results').hide();
      $('.heaters-search').show();
      $('.btn-sort').removeClass('active');
      $('.btn-sort.bestMatchScore').addClass('active');
      window.scrollTo(0, 0);
      try {
        ga('send', 'event', 'PST - Results Page', 'Start Over');
      } catch (err) {}
    });

    $('#get-results').click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      var zipcode = $('input[id$="zipcode"]').val();

      if (zipcode.length < 5) {
        return;
      }

      requestParms.zipCode = zipcode.substring(0, 5);
      SetGeoCodeCookie('', '', requestParms.zipCode);
      $('.heaters-search').hide();
      requestParms.model = '';

      SetGaEvents('Power Source & Location', 'Zip Code', requestParms.zipCode);
      SetGaEvents('Power Source & Location', 'Click', 'See Results');

      sendGAPageView(
        'Results',
        { initial: gaInitial },
        'PST Widget See Results'
      );
      gaInitial = false;
      SubmitRequest();
    });

    function getPSTSettings() {
      return new Promise((resolve, reject) => {
        const moduleId = window.location.pathname.split('/').pop();
        let url =
          'https://www.whmaas.com/api/productselector/settings/' + moduleId;
        if (window.isStaging) {
          url =
            'https://stage.whmaas.com/api/productselector/settings/' + moduleId;
        }
        $.ajax({ method: 'GET', url: url }).done(function(data) {
          var parsedData = JSON.parse(data);
          resolve(parsedData);
        });
      });
    }

    window.SubmitRequest = function(
      showResults,
      resultsFunction,
      shareRouteParams
    ) {
      // utilize route params if they exist
      if (shareRouteParams) {
        (requestParms.averageShowerLength =
          shareRouteParams.averageshowerlength),
          (requestParms.backToBackShowers = shareRouteParams.backtobackshowers),
          (requestParms.customShowerFlowRate = shareRouteParams.showerflowrate),
          (requestParms.energySource = shareRouteParams.fueltype),
          (requestParms.largestBathTub = shareRouteParams.bathtubsize),
          (requestParms.longestShower = shareRouteParams.averageshowerlength),
          // TODO: check on how to get the following parameters
          // HOWEVER: the results page still works without these parameters
          // requestParms.model = shareRouteParams.???,
          // requestParms.prices = shareRouteParams.???,

          (requestParms.simultaneousShowers =
            shareRouteParams.backtobackshowers),
          (requestParms.spaceDepth = shareRouteParams.tankdiameter),
          (requestParms.spaceHeight = shareRouteParams.tankheight),
          (requestParms.spaceWidth = shareRouteParams.tankwidth),
          (requestParms.ventingPreference = shareRouteParams.venttype),
          (requestParms.zipCode = shareRouteParams.postalcode);
        // hide the search
        $('.heaters-search').hide();
      }
      getPSTSettings().then(function(data) {
        if (typeof showResults === 'undefined') {
          showResults = true;
        }
        if (window.resultsOnly && firstTimeThrough) {
          var senderName =
            userPreferences.senderName || userPreferences.quoteRequesterName;
          setSenderNameToView(senderName);
          // set advance setting zip to userPreferences.postalcode
          $('#installationZipcode').val(userPreferences.postalcode);
          firstTimeThrough = false;
          var dataObj = {
            moduleid: userPreferences.moduleid,
            brandid: userPreferences.brandid,
            postalcode: userPreferences.postalcode,
            averageshowerlength: userPreferences.averageshowerlength,
            concurrentshowers: userPreferences.concurrentshowers,
            backtobackshowers: userPreferences.backtobackshowers,
            idealshowerlength: userPreferences.idealshowerlength,
            tankheight: userPreferences.tankheight,
            tankwidth: userPreferences.tankwidth,
            tankdiameter: userPreferences.tankdiameter,
            bathtubsize: userPreferences.bathtubsize,
            fueltype: userPreferences.fueltype,
            venttype: requestParms.ventingPreference
            // ====================
            // if optional parm exists, add it to dataObj
            // ====================
          };
          if (
            typeof userPreferences.showerflowrate !== 'undefined' ||
            typeof requestParms.customShowerFlowRate !== 'undefined'
          ) {
            dataObj.showerflowrate =
              requestParms.customShowerFlowRate ||
              userPreferences.showerflowrate;
          }

          if (typeof userPreferences.bathtubflowrate !== 'undefined') {
            dataObj.bathtubflowrate = userPreferences.bathtubflowrate;
          }

          if (typeof userPreferences.tanktemp !== 'undefined') {
            dataObj.tanktemp = userPreferences.tanktemp;
          }

          if (typeof userPreferences.averageairtemp !== 'undefined') {
            dataObj.airtemp = userPreferences.averageairtemp;
          }

          if (typeof userPreferences.averagegroundwatertemp !== 'undefined') {
            dataObj.groundwatertemp = userPreferences.averagegroundwatertemp;
          }

          if (typeof userPreferences.dailyhotwater !== 'undefined') {
            dataObj.dailyhotwater = userPreferences.dailyhotwater;
          }

          if (typeof userPreferences.installationlocation !== 'undefined') {
            dataObj.installationlocation = userPreferences.installationlocation;
          }
          if (typeof userPreferences.mobilehomeinstallation !== 'undefined') {
            dataObj.mobilehomeinstallation =
              userPreferences.mobilehomeinstallation;
          }

          if (typeof userPreferences.wintergroundwatertemp !== 'undefined') {
            dataObj.wintergroundwatertemp =
              userPreferences.wintergroundwatertemp;
          }

          if (typeof userPreferences.emmission !== 'undefined') {
            dataObj.localemissionsrequirements = userPreferences.emmission;
          }

          if (data.settings.electricityPrice > 0) {
            dataObj.electricity = data.settings.electricityPrice;
          }

          if (data.settings.naturalgasPrice > 0) {
            dataObj.naturalgascost = data.settings.naturalgasPrice;
          }

          if (data.settings.propanePrice > 0) {
            dataObj.propanecost = data.settings.propanePrice;
          }
        } else {
          $('#installationZipcode').val(requestParms.zipCode);
          // create dataObj with default members
          var dataObj = {
            moduleid: userPreferences.moduleid,
            brandid: userPreferences.brandid,
            postalcode: requestParms.zipCode,
            averageshowerlength: requestParms.averageShowerLength,
            concurrentshowers: requestParms.simultaneousShowers,
            backtobackshowers: requestParms.backToBackShowers,
            idealshowerlength: requestParms.longestShower,
            tankheight: requestParms.spaceHeight,
            tankwidth: requestParms.spaceWidth,
            tankdiameter: requestParms.spaceDepth,
            bathtubsize: requestParms.largestBathTub,
            fueltype: userPreferences.fuelType
              ? userPreferences.fuelType
              : requestParms.energySource,
            venttype: requestParms.ventingPreference
            // ====================
            // if optional parm exists, add it to dataObj
            // ====================
          };
          if (
            typeof requestParms.showerFlowRate !== 'undefined' ||
            typeof requestParms.customShowerFlowRate !== 'undefined'
          ) {
            dataObj.showerflowrate =
              requestParms.customShowerFlowRate || requestParms.showerFlowRate;
          }

          if (
            typeof requestParms.BathTubFlowRate !== 'undefined' ||
            typeof userPreferences.bathtubflowrate !== 'undefined'
          ) {
            dataObj.bathtubflowrate =
              requestParms.BathTubFlowRate || userPreferences.bathtubflowrate;
          }

          if (typeof requestParms.TankTemp !== 'undefined') {
            dataObj.tanktemp = requestParms.TankTemp;
          }

          if (typeof requestParms.AverageAirTemp !== 'undefined') {
            dataObj.airtemp = requestParms.AverageAirTemp;
          }

          if (typeof requestParms.AverageGroundWaterTemp !== 'undefined') {
            dataObj.groundwatertemp = requestParms.AverageGroundWaterTemp;
          }

          if (
            typeof requestParms.DailyHotWater !== 'undefined' ||
            typeof userPreferences.dailyHotWater !== 'undefined'
          ) {
            dataObj.dailyhotwater =
              requestParms.DailyHotWater || userPreferences.dailyHotWater;
          }

          if (typeof requestParms.InstallationLocation !== 'undefined') {
            dataObj.installationlocation = requestParms.InstallationLocation;
          }

          if (typeof requestParms.MobileHomeInstallation !== 'undefined') {
            dataObj.mobilehomeinstallation =
              requestParms.MobileHomeInstallation;
          }

          if (typeof requestParms.WinterGroundWaterTemp !== 'undefined') {
            dataObj.wintergroundwatertemp = requestParms.WinterGroundWaterTemp;
          }

          if (typeof requestParms.Emmission !== 'undefined') {
            dataObj.localemissionsrequirements = requestParms.Emmission;
          }

          if (data.settings.electricityPrice > 0) {
            dataObj.electricity = data.settings.electricityPrice;
          }
          if (data.settings.naturalgasPrice > 0) {
            dataObj.naturalgascost = data.settings.naturalgasPrice;
          }
          if (data.settings.propanePrice > 0) {
            dataObj.propanecost = data.settings.propanePrice;
          }
          // overwrite the previous properties if the user changed advanced settings
          if (requestParms.electricityPrice) {
            dataObj.electricity = requestParms.electricityPrice;
          }
          if (requestParms.naturalGasPrice) {
            dataObj.naturalgascost = requestParms.naturalGasPrice;
          }
          if (requestParms.propanePrice) {
            dataObj.propanecost = requestParms.propanePrice;
          }
        }
        $.ajax({
          beforeSend: function beforeSend() {
            pbTimerPct = 0;
            $('div.progress-bar').attr(
              'style',
              'width:' + pbTimerPct * 10 + '%;'
            );
            $('.progressbar').show();
            pbTimerID = setInterval(function() {
              ProgressBarTimer();
            }, 100);
          },
          data: dataObj,
          success: function success(text) {
            getShortCode();
            resultsObj = JSON.parse(text);
            if (!showResults) {
              resultsFunction();
              // return false;
            }
            FormatResults();
            RebuildSliders(WhichSortIsActive(), true);
            $('.heaters-results').show();
            if (window.UpdateLocalDataFields) {
              window.UpdateLocalDataFields();
            }
            window.scrollTo(0, 0);
          }, // end success
          complete: function complete() {
            $('.progressbar').hide();
            clearInterval(pbTimerID);
            if (window.resultsOnly) {
              requestParms = mapToRequestFormat(dataObj);
              if (!window.alreadySetTab) {
                setActiveTab(userPreferences.activeTab);
              }
            }
          }
        }); // end ajax
        function mapToRequestFormat(data) {
          var reformattedObj = {};
          reformattedObj.zipCode = data.postalcode;
          reformattedObj.averageShowerLength = data.averageshowerlength;
          reformattedObj.simultaneousShowers = data.concurrentshowers;
          reformattedObj.backToBackShowers = data.backtobackshowers;
          reformattedObj.longestShower = data.idealshowerlength;
          reformattedObj.spaceHeight = data.tankheight;
          reformattedObj.spaceWidth = data.tankwidth;
          reformattedObj.spaceDepth = data.tankdiameter;
          reformattedObj.largestBathTub = data.bathtubsize;
          reformattedObj.energySource = data.fueltype;

          return reformattedObj;
        }

        function setSenderNameToView(name) {
          if (name === '') {
            name = 'A Customer';
          }
          $('.sender_name').text(name);
        }

        function getShortCode() {
          var activeTab = $('.sortButtons .active').attr('id');

          // add the extra params to the query string for user info and tab selection
          dataObj.activeTab = activeTab;
          dataObj.senderName = $('#share-form #share_name').val();
          dataObj.quoteRequesterName = $('#quote-form #quote_name').val();
          dataObj.userID = userPreferences.userID;

          var queryString = $.param(dataObj);

          const rParams = queryString.split('&');
          const routeValues = {};
          rParams.forEach(d => {
            var ky = d.split('=')[0];
            var vl = d.split('=')[1];
            var newValue = isNaN(vl) ? vl : parseFloat(vl);
            routeValues[ky] = newValue;
          });

          var bitlyURL = `https://pst.hotwater.com/${routeValues.moduleid}?`;

          bitlyURL = encodeURI(bitlyURL) + encodeURIComponent(queryString);
          var accessToken = '7cffd899a792fe5b750d1e26c80684d6e2d13c97';
          $.support.cors = true;
          $.ajax({
            dataType: 'jsonp',
            url:
              'https://api-ssl.bitly.com/v3/shorten?access_token=' +
              accessToken +
              '&longUrl=' +
              bitlyURL,
            data: dataObj
          })
            .done(function(response) {
              console.log('bitly return', response.data.hash);
              setShortCodeToView(response.data.hash);
              return response.data.hash;
            })
            .error(function(jq, jx, error) {});
        }

        function setShortCodeToView(code) {
          $('.short-code').text(code);
          $('.short-code-input').val(code);
        }

        $('.sortButtons button').on('click', function() {
          getShortCode();
        });

        // form submission
        // needed to move into this file to update the senders name to pass along to the results page
        $('#share-form').on('submit', function(e) {
          e.preventDefault();
          sendGAPageView(
            'ShareRecommendationFormSend',
            {},
            'Share Recommendation Sent'
          );
          var $form = $(this);
          var formData = $form.serialize();
          var endPoint = $form.attr('action');
          sendAjax(formData, endPoint);
          toggleThanks('share');
        });

        $('#quote-form').on('submit', function(e) {
          e.preventDefault();
          sendGAPageView(
            'RequestaQuoteFormSend',
            {},
            'Request A Quote Submited'
          );
          var $form = $(this);
          var formData = $form.serialize();
          var endPoint = $form.attr('action');
          sendAjax(formData, endPoint);
          toggleThanks('quote');
        });

        $('#share_name').on('blur', function() {
          getShortCode();
        });

        $('#quote_name').on('blur', function() {
          getShortCode();
        });

        $("[data-target='#modalShare']").on('click', function(e) {
          $('.share-section').show();
          $('.share-thanks').hide();
        });

        $(document).delegate("[data-target='#quoteModal']", 'click', function(
          e
        ) {
          $('.quote-section').show();
          $('.quote-thanks').hide();
        });

        function toggleThanks(type) {
          $('.' + type + '-section').hide();
          $('.' + type + '-thanks').show();
        }

        function sendAjax(data, endpoint) {
          $.ajax({
            url: endpoint,
            data: data,
            type: 'POST'
          })
            .done(function(data) {})
            .error(function(error) {})
            .always(function(response) {});
        }
      });
    };

    const routeParams = window.location.search.split('&');
    const shareResultsRouteParams = {};
    if (routeParams.length > 1) {
      routeParams.forEach(d => {
        var key = d.split('=')[0];
        var v = d.split('=')[1];

        var value = isNaN(v) ? v : parseFloat(v);

        shareResultsRouteParams[key] = value;
      });
      window.SubmitRequest(true, null, shareResultsRouteParams);
    }

    // set up results if they are being passed through the url
    if (window.resultsOnly) {
      window.SubmitRequest();
    }

    function setActiveTab(id) {
      window.alreadySetTab = true;
      $('#' + id).click();
    }

    var FormatResults = function FormatResults() {
      // determine tanks and tankless
      var list = [];
      list = BuildListOfUnits('bestMatchScore');
      ShowListOfUnits(list);
      SetGeoCodeCookie(
        resultsObj.prices.City,
        resultsObj.prices.State,
        resultsObj.prices.ZipCode
      );

      var inMobile = $('#is-mobile').length > 0;

      if (inMobile) {
        $('button.modalAdvancedOptions').show();
      }
    };

    var ShowListOfUnits = function ShowListOfUnits(list) {
      $('#heaters-index').html('');

      if (list.length < 1) {
        RenderNoMatches();
        return;
      }

      $('#buttonsWithResults').show();
      $('#buttonsWithoutResults').hide();

      for (var i = 0; i < list.length; i++) {
        RenderAUnit(list[i]);
      }
    };

    $('.btn-sort').click(function(e) {
      var list = [];
      var sortBy = '';
      $('.btn-sort').removeClass('active');
      $(this).addClass('active');

      if ($(this).hasClass('bestMatchScore')) {
        list = BuildListOfUnits('bestMatchScore');
        sortBy = 'BestMatch';
        try {
          sendGAPageView('MeetsYourNeeds', {}, 'PST Widget Tab Change');
        } catch (err) {}
      } else if ($(this).hasClass('moreHotWaterScore')) {
        list = BuildListOfUnits('moreHotWaterScore');
        sortBy = 'BestHotWater';
        try {
          sendGAPageView('MoreHotWater', {}, 'PST Widget Tab Change');
        } catch (err) {}
      } else {
        // moreSavingsScore
        list = BuildListOfUnits('moreSavingsScore');
        sortBy = 'BestSavings';
        try {
          sendGAPageView('LowerEnergyCost', {}, 'PST Widget Tab Change');
        } catch (err) {}
      }

      try {
        ga(
          'send',
          'event',
          'PST - Results Page Sorted By' + sortBy,
          'Start Over'
        );
      } catch (err) {}
      ShowListOfUnits(list);
      RebuildSliders(sortBy, true);
    });

    var WhichSortIsActive = function WhichSortIsActive() {
      var ret = '';
      $('.btn-sort').each(function(ixd) {
        if ($(this).hasClass('active')) {
          if ($(this).hasClass('bestMatchScore')) {
            ret = 'BestMatch';
          } else if ($(this).hasClass('moreHotWaterScore')) {
            ret = 'BestHotWater';
          } else {
            // moreSavingsScore
            ret = 'BestSavings';
          }
        }
      });
      return ret;
    };

    var BuildListOfUnits = function BuildListOfUnits(sortType) {
      var unitList = [];
      var tankCount = tankUnitsToShow;
      var tanklessCount = tanklessUnitsToShow;
      if (sortType == 'bestMatchScore') {
        unitList = BuildListOfUnitsInternal(
          resultsObj.BestMatch,
          tankCount,
          tanklessCount
        );
      } else if (sortType == 'moreHotWaterScore') {
        unitList = BuildListOfUnitsInternal(
          resultsObj.BestHotWater,
          tankCount,
          tanklessCount
        );
      } else {
        // moreSavingsScore
        unitList = BuildListOfUnitsInternal(
          resultsObj.BestSavings,
          tankCount,
          tanklessCount
        );
      }
      return unitList;
    };

    var BuildListOfUnitsInternal = function BuildListOfUnitsInternal(
      units,
      tankCount,
      tanklessCount
    ) {
      var tankList = [];
      var tanklessList = [];
      var returnList = [];
      // get the tanks
      for (var i = 0; i < units.length; i++) {
        if (units[i].Tankless == false && tankList.length < 10) {
          tankList.push(units[i]);
        }
      }
      // get the tankless
      for (var i = 0; i < units.length; i++) {
        if (units[i].Tankless == true && tanklessList.length < 10) {
          tanklessList.push(units[i]);
        }
      }

      // if not enough tankless to fill list increase tankCount by the difference
      if (tanklessList.length < tanklessCount) {
        tankCount += tanklessCount - tanklessList.length;
      }
      // if not enough tank to fill list increase tanklessCount by the difference
      if (tankList.length < tankCount) {
        tanklessCount += tankCount - tankList.length;
      }

      for (var i = 0; i < tankCount && i < tankList.length; i++) {
        returnList.push(tankList[i]);
      }

      for (var i = 0; i < tanklessCount && i < tanklessList.length; i++) {
        returnList.push(tanklessList[i]);
      }

      return returnList;
    };

    var RenderNoMatches = function() {
      var pathname = window.location.pathname.split('/');
      var moduleId = pathname[pathname.length - 1];
      var url =
        'https://www.whmaas.com/api/productselector/settings/' + moduleId;
      if (window.isStaging) {
        var url =
          'https://stage.whmaas.com/api/productselector/settings/' + moduleId;
      }
      var hrefWhereToBuy = '';
      var companyName = '';

      $.ajax({
        method: 'GET',
        url: url
      }).done(function(data) {
        var parsedData = JSON.parse(data);
        if (parsedData.settings.brand_id === 1) {
          hrefWhereToBuy = 'http://www.hotwater.com/where-to-buy/';
        } else if (parsedData.settings.brand_id === 6) {
          hrefWhereToBuy = 'http://www.statewaterheaters.com/where-to-buy/';
        }
        if (parsedData.settings.name !== null) {
          companyName = parsedData.settings.name;
        }

        var template = '<article class="result tank-0">';
        template += '<div class="result-item">';
        template += '<p>No Results</p>';
        template += `<p>We are unable to determine the best water heater for you with the available information. Please contact ${companyName} for more information.</p>`;
        template += '</div>';
        template += '</article>';
        $('#heaters-index').empty();
        $('#heaters-index').append(template);
        // code for no matches
        SetGaEvents('results', 'load', 'no models');
        $('#buttonsWithResults').hide();
        $('#buttonsWithoutResults').show();
      });
    };

    var RenderAUnit = function RenderAUnit(current) {
      var url = current.ContentUrl;
      var staging = 'whirlpool.waterheaterdev.com';

      if (window.location.href.indexOf(staging) >= 0) {
        url = url.replace('www.whirlpoolwaterheaters.com', staging);
      }

      var template = productTemplate(current);

      $('#heaters-index').append(template);

      // Code to grab data after units are shown
      SetGaEvents('results', 'load', current.ModelNumber);
    };

    function includeButtons(product) {
      var phoneClass =
        userPreferences.primaryContactMethod === 'phone'
          ? 'primary-contact-method'
          : '';
      var emailClass =
        userPreferences.primaryContactMethod === 'email'
          ? 'primary-contact-method'
          : '';
      var productPageClass =
        userPreferences.primaryContactMethod === 'product page'
          ? 'primary-contact-method'
          : '';
      var fullButtonResponse = '';
      var callButton = `<button type="button" class="btn btn-ghost contact-method ${phoneClass}"
        data-toggle="modal" data-target="#callModal" data-role="none">
        ${userPreferences.phoneButtonText}
        </button>`;
      var quoteButton = `<button type="button" class="btn btn-ghost contact-method ${emailClass}"
        data-toggle="modal" data-target="#quoteModal" data-role="none">
        ${userPreferences.emailButtonText}
        </button>`;
      var productPageButton = `<a href="${
        product.ProductPage
      }" target="_blank"><button type="button" class="btn btn-ghost contact-method ${productPageClass}"
        data-role="none">
        ${userPreferences.productPageButtonText}
        </button></a>`;

      if (userPreferences.showPhone) {
        fullButtonResponse += callButton;
      }
      if (userPreferences.showEmail) {
        fullButtonResponse += quoteButton;
      }
      if (
        userPreferences.showProductPage &&
        product.ProductPage !== null &&
        product.ProductPage !== ''
      ) {
        fullButtonResponse += productPageButton;
      }
      return fullButtonResponse;
    }

    function includeRatings(current) {
      var bvUrl = 'https://www.hotwater.com/bv/ratings.aspx?id=';
      if (parseInt(userPreferences.brandid) === 6) {
        bvUrl = "https://www.statewaterheaters.com/bv/ratings.aspx?id=";
      }
      return (
        '<p class="reviews"><iframe frameborder="0" height="40" src="' +
        bvUrl +
        current.ModelNumber.replace(/\-|\(|\)| /g, '') +
        '"></iframe></p>'
      );
    }

    var RebuildSliders = function RebuildSliders(sortBy, destroy) {
      RebuildSlidersMaxBasedOnResponse(
        sliderSingleShowerLength,
        sortBy,
        destroy
      );
      RebuildSlidersMaxBasedOnResponse(
        sliderBackToBackShowers,
        sortBy,
        destroy
      );
      RebuildSlidersMaxBasedOnResponse(
        sliderSimultaneousShowers,
        sortBy,
        destroy
      );
      RebuildSlidersMaxBasedOnResponse(
        sliderAverageShowerLength,
        sortBy,
        destroy
      );
      RebuildSlidersMaxBasedOnResponse(sliderTubSize, sortBy, destroy);
    };

    var RebuildSlidersMaxBasedOnResponse = function RebuildSlidersMaxBasedOnResponse(
      slider,
      sortBy,
      destroy
    ) {
      if (typeof resultsObj.Count == 'undefined') {
        resultsObj.Count = 0;
      }

      var maxSingleShowerLen = 0;
      var maxBackToBackShowers = 0;
      var maxSimultaneousShowers = 0;
      var maxTubSize = 0;
      var maxAverageShowerLength = 25;
      switch (sortBy) {
        case 'BestMatch':
          for (var i = 0; i < resultsObj.Count; i++) {
            if (resultsObj.BestMatch[i].ShowerLength > maxSingleShowerLen) {
              maxSingleShowerLen = resultsObj.BestMatch[i].ShowerLength;
            }
            if (
              resultsObj.BestMatch[i].BackToBackShowers > maxBackToBackShowers
            ) {
              maxBackToBackShowers = resultsObj.BestMatch[i].BackToBackShowers;
            }
            if (
              resultsObj.BestMatch[i].ShowersAtSameTime > maxSimultaneousShowers
            ) {
              maxSimultaneousShowers =
                resultsObj.BestMatch[i].ShowersAtSameTime;
            }
            if (resultsObj.BestMatch[i].MaxTubSize > maxTubSize) {
              maxTubSize = resultsObj.BestMatch[i].MaxTubSize;
            }
          }
          break;
        case 'BestHotWater':
          for (var i = 0; i < resultsObj.Count; i++) {
            if (resultsObj.BestHotWater[i].ShowerLength > maxSingleShowerLen) {
              maxSingleShowerLen = resultsObj.BestHotWater[i].ShowerLength;
            }
            if (
              resultsObj.BestHotWater[i].BackToBackShowers >
              maxBackToBackShowers
            ) {
              maxBackToBackShowers =
                resultsObj.BestHotWater[i].BackToBackShowers;
            }
            if (
              resultsObj.BestHotWater[i].ShowersAtSameTime >
              maxSimultaneousShowers
            ) {
              maxSimultaneousShowers =
                resultsObj.BestHotWater[i].ShowersAtSameTime;
            }
            if (resultsObj.BestHotWater[i].MaxTubSize > maxTubSize) {
              maxTubSize = resultsObj.BestHotWater[i].MaxTubSize;
            }
          }
          break;
        case 'BestSavings':
          for (var i = 0; i < resultsObj.Count; i++) {
            if (resultsObj.BestSavings[i].ShowerLength > maxSingleShowerLen) {
              maxSingleShowerLen = resultsObj.BestSavings[i].ShowerLength;
            }
            if (
              resultsObj.BestSavings[i].BackToBackShowers > maxBackToBackShowers
            ) {
              maxBackToBackShowers =
                resultsObj.BestSavings[i].BackToBackShowers;
            }
            if (
              resultsObj.BestSavings[i].ShowersAtSameTime >
              maxSimultaneousShowers
            ) {
              maxSimultaneousShowers =
                resultsObj.BestSavings[i].ShowersAtSameTime;
            }
            if (resultsObj.BestSavings[i].MaxTubSize > maxTubSize) {
              maxTubSize = resultsObj.BestSavings[i].MaxTubSize;
            }
          }
          break;
      }
      if (maxSingleShowerLen == 0) maxSingleShowerLen = 100;
      if (maxBackToBackShowers == 0) maxBackToBackShowers = 5;
      if (maxSimultaneousShowers == 0) maxSimultaneousShowers = 5;
      if (maxTubSize == 0) maxTubSize = 100;

      var settings = {
        start: 1,
        step: 1,
        orientation: 'horizontal',
        range: { min: 1, max: 5 },
        format: wNumb({ decimals: 0 })
      };

      switch (slider.id) {
        case 'sliderSingleShowerLength':
          settings.start = requestParms.longestShower;
          settings.range.max = Math.round(maxSingleShowerLen);
          break;
        case 'sliderBackToBackShowers':
          settings.start = requestParms.backToBackShowers;
          settings.range.max = Math.round(maxBackToBackShowers);
          break;
        case 'sliderSimultaneousShowers':
          settings.start = requestParms.simultaneousShowers;
          settings.range.max = Math.round(maxSimultaneousShowers);
          break;
        case 'sliderTubSize':
          settings.start = requestParms.largestBathTub;
          settings.range.max = Math.round(maxTubSize);
          break;
        case 'sliderAverageShowerLength':
          settings.start = requestParms.averageShowerLength;
          settings.range.max = Math.round(maxAverageShowerLength);
          break;
      }

      if (typeof destroy !== 'undefined') {
        slider.noUiSlider.destroy();
      }

      noUiSlider.create(slider, settings);
      slider.noUiSlider.on('update', function() {
        $(slider)
          .children('div')
          .children('div')
          .children('div')
          .attr('data-content', Math.round(slider.noUiSlider.get()));
        ignoreUpdate = false;
      });
      slider.noUiSlider.on('change', function() {
        if (ignoreUpdate) return;
        switch (slider.id) {
          case 'sliderSingleShowerLength':
            requestParms.longestShower = slider.noUiSlider.get();
            break;
          case 'sliderBackToBackShowers':
            requestParms.backToBackShowers = slider.noUiSlider.get();
            break;
          case 'sliderSimultaneousShowers':
            requestParms.simultaneousShowers = slider.noUiSlider.get();
            break;
          case 'sliderTubSize':
            requestParms.largestBathTub = slider.noUiSlider.get();
            break;
          case 'sliderAverageShowerLength':
            requestParms.averageShowerLength = slider.noUiSlider.get();
            break;
        }

        sendGAPageView(
          'AdvancedResults',
          {
            advanded: true
          },
          'Advanced Results'
        );

        SubmitRequest();
      });
      slider.noUiSlider.on('update', function() {
        $(slider)
          .children('div')
          .children('div')
          .children('div')
          .attr('data-content', Math.round(slider.noUiSlider.get()));
        ignoreUpdate = false;
      });
    };

    // sliders on desktop results page
    var sliderSingleShowerLength = document.getElementById(
      'sliderSingleShowerLength'
    );
    var sliderBackToBackShowers = document.getElementById(
      'sliderBackToBackShowers'
    );
    var sliderSimultaneousShowers = document.getElementById(
      'sliderSimultaneousShowers'
    );
    var sliderAverageShowerLength = document.getElementById(
      'sliderAverageShowerLength'
    );
    var sliderTubSize = document.getElementById('sliderTubSize');

    RebuildSliders('BestMatch');

    $('#pst-quote-contact-buttons button').click(function() {
      SetGaEvents('Contact', 'Click', $(this).text());
    });

    function productTemplate(product) {
      return `
        <article class="result tank-0">
          <div class="result-item">
            <div class="result-image">
              <img src="${product.ModelImage}" class="result-thumb">
            </div>

            <div class="result-info">
              <h1 class="result-title">${
                product.ModelNumber
              } ${product.ModelName} ${product.ExtendedDescription}</h1>
              <div class="result-facts">
                <ul>
                  <li>
                    <div class="result-numbers">
                      <strong>${
                        parseFloat(product.ShowerLength) < 0
                          ? 'Unlimited'
                          : `${product.ShowerLength} minutes`
                      }
                      </strong>
                      <span class="meta">single shower length</span>
                    </div>
                  </li>

                  <li>
                    <div class="result-numbers">
                      <strong>${
                        parseFloat(product.BackToBackShowers) < 0
                          ? 'Unlimited'
                          : `${product.BackToBackShowers} showers`
                      }
                      </strong>
                      <span class="meta">back-to-back</span>
                    </div>
                  </li>

                  <li>
                    <div class="result-numbers">
                      <strong>${
                        parseFloat(product.MaxTubSize) < 0
                          ? 'Unlimited'
                          : `${Math.round(product.MaxTubSize)} gallons`
                      }
                      </strong>
                      <span class="meta">max tub size</span>
                    </div>
                  </li>

                  <li>
                    <div class="result-numbers">
                      <strong>${
                        parseFloat(product.ShowersAtSameTime) < 0
                          ? 'Unlimited'
                          : `${product.ShowersAtSameTime} showers`
                      }
                      </strong>
                      <span class="meta">at the same time</span>
                    </div>
                  </li>

                  <li>
                    <div class="result-numbers">
                      <strong>${product.LimitedWarranty} years</strong>
                      <span class="meta">limited warranty</span>
                    </div>
                  </li>

                  <li>
                    <div class="result-numbers">
                      <strong>${product.AnnualCost}/YEAR</strong><br>
                      <span class="meta">estimated energy cost</span>
                    </div>
                  </li>
                </ul>

                <div class="row">
                  <div class="results-cta-block">
                    <div class="col-sm-4 col-xs-12">
                      ${includeRatings(product)}
                    </div>
                    <div class="col-sm-8 col-xs-12 results-cta" data-model="${
                      product.ModelNumber
                    }">
                      ${includeButtons(product)}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </article>
      `;
    }
  });

  // Adding Popover functionality to Contractor Feature Icons
  $(function() {
    $('.btn-popover').popover();
  });

  $(function() {
    $('[data-toggle="tooltip"]').tooltip();
  });
})(window.jQuery, window, document);
